import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LockOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { Alert, Button, Form, Input } from "antd";
import { useState, useEffect, useRef } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import jwt_decode from "jwt-decode";
import Logo from "../../assets/images/logo2.png";
import { login } from "../../store/actions/authActionCreators";
import { isUserLoggedIn } from "../../util/auth.util";
import { addAuthToLocalStorage } from "../../util/localStorage.util";

const Adminlogin = () => {
  const [form] = Form.useForm();

  const passwordInput = useRef(null);

  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();
  const [serverError, setServerError] = useState<string | null>(null);

  useEffect(() => {
    if (passwordInput && passwordInput.current) {
      // @ts-ignore: Object is possibly 'null'.
      passwordInput.current.focus();
    }
  }, [passwordInput]);

  const onFinish = async (values: any) => {
    setServerError(null);
    setLoading(true);
    const [response, err]: Array<any> = await login({ ...values });
    if (response) {
      if (!response.data.data.authenticated) {
        setServerError("Invalid credentials");
        setLoading(false);
        return;
      }
      //TODO: change to get its value from role
      response.data["isAdmin"] = true;
      const decoded: any = jwt_decode(response.data.data.token);
      response.data["permissions"] = decoded ? decoded["Permissions"] : [];
      response.data["role"] = decoded ? decoded["role"] : "";
      response.data["health"] = decoded ? decoded["HealthCheckUISecret"] : "";
      addAuthToLocalStorage(response.data);
      window.setTimeout(() => {
        setLoading(false);
        history.push("/");
        window.location.href = window.location.href;
      }, 1000);
    }
    if (err) {
      if (err.response.data.succeeded) {
        setServerError(err.response.data.data.errors[0]);
      } else {
        setServerError(err.response.data.message);
      }
      setLoading(false);
    }
  };

  if (isUserLoggedIn()) {
    return <Redirect to="/" />;
  }

  const resendLink = () => {
    history.push("/resend-link");
  };

  return (
    <div className="authentication__wrapper">
      <div className="authentication__content login">
        <div>
          <img src={Logo} alt="" className="logo__img" />
          <div className="form__wrapper">
            <div className="alert__wrapper">
              {serverError && (
                <Alert
                  message={serverError}
                  type="error"
                  closable
                  showIcon
                  action={
                    serverError === "Email is not verified." ? (
                      <Button size="small" onClick={resendLink}>
                        RESEND LINK?
                      </Button>
                    ) : (
                      ""
                    )
                  }
                />
              )}
            </div>
            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Email is required",
                  },
                ]}
              >
                <Input
                  style={{ width: "100%" }}
                  ref={passwordInput}
                  placeholder="Email"
                  prefix={<MailOutlined />}
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Password is required",
                  },
                ]}
              >
                <Input.Password
                  style={{ width: "100%" }}
                  placeholder="Password"
                  prefix={<LockOutlined />}
                  iconRender={(visible) =>
                    visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                  }
                />
              </Form.Item>
              <Form.Item>
                <Button
                  loading={loading}
                  className="login__btn w__100"
                  htmlType="submit"
                >
                  Sign In
                </Button>
              </Form.Item>
              <p>
                Forgot password? Click{" "}
                <Link to="/reset-password-link">here</Link> to reset.
              </p>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Adminlogin;
